"use client";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import { config } from "@fortawesome/fontawesome-svg-core";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { GlobalStyle } from "@portal/app/_components/theme/GlobalStyle";
// eslint-disable-next-line no-restricted-imports -- This rule applies everywhere except where the theme is being initially created.
import { theme } from "@portal/app/_components/theme/theme";
import { ToastProvider } from "@portal/app/_components/context/ToastProvider";
import { ConfirmProvider } from "material-ui-confirm";

config.autoAddCss = false;

export const DreamClientThemeProvider = ({ children }: React.PropsWithChildren) => (
  <MUIThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <ToastProvider>
        <ConfirmProvider>
          <GlobalStyle />
          {children}
        </ConfirmProvider>
      </ToastProvider>
    </LocalizationProvider>
  </MUIThemeProvider>
);
